// Shared DEFCON level colors + ordering (5 = peace, 1 = go nuclear).
export const DEFCON_COLORS = { 5: "#32D74B", 4: "#FFD60A", 3: "#FF9500", 2: "#FF3B30", 1: "#8B0000" };
export const DEFCON_ORDER = [5, 4, 3, 2, 1];

// Turn a stream URL into an embeddable player src. Supports YouTube (video/live/
// channel), Twitch (needs the current hostname as `parent`), Kick, and direct
// video files. Returns null when the URL can't be embedded (e.g. a YouTube
// @handle/live link with no video id) — callers then fall back to a link-out.
export function toStreamEmbed(url, hostname) {
  if (!url) return null;
  try {
    const u = new URL(url);
    const host = u.hostname.replace(/^www\./, "");
    if (host === "youtu.be") {
      const id = u.pathname.slice(1).split("/")[0];
      if (id) return { type: "youtube", src: `https://www.youtube.com/embed/${id}?autoplay=1&mute=1` };
    }
    if (host.endsWith("youtube.com")) {
      const v = u.searchParams.get("v");
      if (v) return { type: "youtube", src: `https://www.youtube.com/embed/${v}?autoplay=1&mute=1` };
      const m = u.pathname.match(/\/(?:live|embed|shorts)\/([\w-]+)/);
      if (m) return { type: "youtube", src: `https://www.youtube.com/embed/${m[1]}?autoplay=1&mute=1` };
      const ch = u.pathname.match(/\/channel\/([\w-]+)/);
      if (ch) return { type: "youtube", src: `https://www.youtube.com/embed/live_stream?channel=${ch[1]}&autoplay=1&mute=1` };
      return null; // @handle/live cannot be embedded without a video/channel id
    }
    if (host.endsWith("twitch.tv")) {
      const chan = u.pathname.split("/").filter(Boolean)[0];
      const parent = hostname || (typeof window !== "undefined" ? window.location.hostname : "");
      if (chan && parent) return { type: "twitch", src: `https://player.twitch.tv/?channel=${chan}&parent=${parent}&autoplay=true&muted=true` };
    }
    if (host.endsWith("kick.com")) {
      const chan = u.pathname.split("/").filter(Boolean)[0];
      if (chan) return { type: "kick", src: `https://player.kick.com/${chan}` };
    }
    if (/\.(mp4|webm|ogg)(\?|$)/i.test(u.pathname)) return { type: "file", src: url };
  } catch {}
  return null;
}

